import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { createBlock, t } from '../../../utils';
import { BasicBlock } from '../../../components/BasicBlock';

export type IColumn = IBlockData<
    {
        'background-color'?: string;
        border?: string;
        'border-radius'?: string;
        'inner-border'?: string;
        'inner-border-radius'?: string;
        padding?: string;
        'text-align'?: string;
        'vertical-align'?: string;
        width?: string;
    },
    {}
>;

export const Column = createBlock<IColumn>({
    get name() {
        return t('Column');
    },
    type: BasicType.COLUMN,
    create: (payload: any) => {
        const defaultData: IColumn = {
            type: BasicType.COLUMN,
            data: {
                value: {},
            },
            attributes: {
                padding: '0px 0px 0px 0px',
                border: 'none',
                'vertical-align': 'top',
            },
            children: [],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.SECTION, BasicType.GROUP],

    render(params: any) {
        return (
            <BasicBlock
                params={params}
                tag='mj-column'
            />
        );
    },
});
